import Vue from 'vue'
import App from './App.vue'
import router from './router'

import Vant, { Toast } from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant)
Vue.prototype.$toast = Toast

Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')


// 禁止手势缩放
document.addEventListener('gesturestart', function (e) {
  e.preventDefault();
});
// 禁止双击放大
document.addEventListener('dblclick', function (e) {
  e.preventDefault();
});
